// import React, { useState } from 'react';
// import { Tabs, Tab, Box } from '@mui/material';
// import NewRequests from './NewRequests';
// import TodaysAppointments from './TodaysAppointments';
// import ApprovedAppointments from './ApprovedAppointments';
// import PastAppointments from './PastAppointments';
// import { useNavigate } from 'react-router-dom';

// const STORAGE_KEY = "appointmentTabsData";
// const SECRET_KEY = process.env.REACT_APP_USER_ENC_DEC_KEY;

// const AllAppointments = () => {
//   const [selectedTab, setSelectedTab] = useState(0);
//   const navigate = useNavigate();
//   const [appointmetsTabs, setAppointmetsTabs] = useState([]);
//   const handleTabChange = (_, newValue) => {
//     setSelectedTab(newValue);
//   };

//   const handleOpenTab = (appointmets) => {
//     const existingIndex = appointmetsTabs.findIndex((tab) => tab.pid === appointmets.pid);
//     if (existingIndex === -1) {
//       const newTab = {
//         pid: appointmets.pid,
//         uuid: appointmets.uuid,
//         name: `${appointmets.fname} ${appointmets.lname}`,
//         email: appointmets.email,
//         tabId: appointmetsTabs.length + 2,
//       };
//       const updatedTabs = [...appointmetsTabs, newTab];
//       setAppointmetsTabs(updatedTabs);
//       setSelectedTab(updatedTabs.length + 1);
//       setTimeout(() => {
//         navigate(`/provider/patient/PatientDetails/${appointmets.uuid}/${appointmets.pid}`);
//       }, 100);
//     } else {
//       setSelectedTab(existingIndex + 2);
//     //   navigate(`/provider/patient/PatientDetails/${appointmetsTabs[existingIndex].uuid}/${appointmetsTabs[existingIndex].pid}`);
//       navigate(`/provider/patient/appointment/${appointmetsTabs[existingIndex].uuid}/${appointmetsTabs[existingIndex].pid}/${appointmetsTabs[existingIndex].pc_eid}`);

//     }
//   };

//   return (
//     <Box>
//       {/* Tabs Section */}
//       <Tabs value={selectedTab} onChange={handleTabChange} variant="fullWidth">
//         <Tab label="New Requests" />
//         <Tab label="Today's Appointments" />
//         <Tab label="Approved Appointments" />
//         <Tab label="Past Appointments" />
//       </Tabs>

//       {/* Content Section */}
//       <Box sx={{ marginTop: 2 }}>
//         {selectedTab === 0 && <NewRequests onAppointmenttSelect={handleOpenTab}/>}
//         {selectedTab === 1 && <TodaysAppointments />}
//         {selectedTab === 2 && <ApprovedAppointments />}
//         {selectedTab === 3 && <PastAppointments />}
//       </Box>
//     </Box>
//   );
// };

// export default AllAppointments;



// import React, { useEffect, useState } from "react";
// import { Tabs, Tab, Box, IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import NewRequests from "./NewRequests";
// import TodaysAppointments from "./TodaysAppointments";
// import ApprovedAppointments from "./ApprovedAppointments";
// import PastAppointments from "./PastAppointments";
// import { useNavigate } from "react-router-dom";
// import CryptoJS from "crypto-js";

// const STORAGE_KEY = "appointmentTabsData";
// const SECRET_KEY = process.env.REACT_APP_USER_ENC_DEC_KEY;

// const AllAppointments = () => {
//   const navigate = useNavigate();
//   const [selectedTab, setSelectedTab] = useState(0);
//   const [appointmentTabs, setAppointmentTabs] = useState([]);

//   // Encrypt Data
//   const encryptData = (data) => {
//     return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
//   };

//   // Decrypt Data
//   const decryptData = (encryptedData) => {
//     try {
//       const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
//       return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//     } catch (error) {
//       console.error("Error decrypting data:", error);
//       return null;
//     }
//   };

//   // Load Stored Tabs on Mount
//   useEffect(() => {
//     const storedData = sessionStorage.getItem(STORAGE_KEY);
//     if (storedData) {
//       const decryptedData = decryptData(storedData);
//       if (decryptedData && decryptedData.tabs.length > 0) {
//         setAppointmentTabs(decryptedData.tabs);
//         setSelectedTab(decryptedData.lastTab >= 0 ? decryptedData.lastTab : 0);
//       }
//     }
//   }, []);

//   // Save Tabs in Storage on Change
//   useEffect(() => {
//     const encryptedTabs = encryptData({ tabs: appointmentTabs, lastTab: selectedTab });
//     sessionStorage.setItem(STORAGE_KEY, encryptedTabs);
//   }, [appointmentTabs, selectedTab]);

//   // Open a New Appointment Tab
//   const handleOpenTab = (appointment) => {
//     console.log("appointment",appointment)
//     const existingIndex = appointmentTabs.findIndex((tab) => tab.pid === appointment.pc_pid);

//     if (existingIndex === -1) {
//       const newTab = {
//         pid: appointment.pc_pid,
//         uuid: appointment.patient_uuid,
//         eid: appointment.pc_eid,
//         name: `${appointment.fname} ${appointment.lname}`,
//         email: appointment.email,
//         tabId: appointmentTabs.length + 4, // Offset existing tabs
//       };
//       const updatedTabs = [...appointmentTabs, newTab];
//       setAppointmentTabs(updatedTabs);
//       setSelectedTab(updatedTabs.length + 3);

//       setTimeout(() => {
//         navigate(`/provider/appointment/appot-data/${appointment.patient_uuid}/${appointment.pc_pid}/${appointment.pc_eid}`);
//       }, 100);
//     } else {
//       setSelectedTab(existingIndex + 4);
//       navigate(`/provider/appointment/appot-data/${appointmentTabs[existingIndex].patient_uuid}/${appointmentTabs[existingIndex].pc_pid}/${appointmentTabs[existingIndex].pc_eid}`);
//     }
//   };

//   // Close a Tab
//   const handleCloseTab = (index) => {
//     const updatedTabs = appointmentTabs.filter((_, i) => i !== index);
//     setAppointmentTabs(updatedTabs);

//     if (updatedTabs.length === 0) {
//       setSelectedTab(0);
//       navigate("/provider/appointments");
//     } else {
//       setSelectedTab(Math.max(0, selectedTab - 1));
//     }
//   };

//   // Handle Tab Change
//   const handleTabChange = (_, newValue) => {
//     setSelectedTab(newValue);

//     if (newValue === 0) {
//       navigate("/provider/appointments");
//     } else if (newValue === 1) {
//       navigate("/provider/appointments");
//     } else if (newValue === 2) {
//       navigate("/provider/appointments");
//     } else if (newValue === 3) {
//       navigate("/provider/appointments");
//     } else {
//       const selectedAppointment = appointmentTabs[newValue - 4];
//       if (selectedAppointment) {
//         navigate(`/provider/appointment/appot-data/${selectedAppointment.patient_uuid}/${selectedAppointment.pc_pid}/${selectedAppointment.pc_eid}`);
//       }
//     }
//   };

//   return (
//     <Box>
//       {/* Tabs Section */}
//       <Tabs value={selectedTab} onChange={handleTabChange} variant="scrollable">
//         <Tab label="New Requests" />
//         <Tab label="Today's Appointments" />
//         <Tab label="Approved Appointments" />
//         <Tab label="Past Appointments" />

//         {appointmentTabs.map((tab, index) => (
//           <Tab
//             key={tab.pid}
//             label={
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 {tab.name}
//                 <IconButton
//                   size="small"
//                   onClick={() => handleCloseTab(index)}
//                   sx={{ marginLeft: 1 }}
//                 >
//                   <CloseIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             }
//           />
//         ))}
//       </Tabs>

//       {/* Content Section */}
//       <Box sx={{ marginTop: 2 }}>
//         {selectedTab === 0 && <NewRequests onAppointmentSelect={handleOpenTab} />}
//         {selectedTab === 1 && <TodaysAppointments onAppointmentSelect={handleOpenTab}/>}
//         {selectedTab === 2 && <ApprovedAppointments onAppointmentSelect={handleOpenTab}/>}
//         {selectedTab === 3 && <PastAppointments onAppointmentSelect={handleOpenTab}/>}
//       </Box>
//     </Box>
//   );
// };

// export default AllAppointments;


import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NewRequests from "./NewRequests";
import TodaysAppointments from "./TodaysAppointments";
import ApprovedAppointments from "./ApprovedAppointments";
import PastAppointments from "./PastAppointments";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const STORAGE_KEY = "appointmentTabsData";
const SECRET_KEY = process.env.REACT_APP_USER_ENC_DEC_KEY;

const AllAppointments = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const [appointmentTabs, setAppointmentTabs] = useState([]);

  // Encrypt Data
  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  };

  // Decrypt Data
  const decryptData = (encryptedData) => {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
      console.error("Error decrypting data:", error);
      return null;
    }
  };

  // Load Stored Tabs on Mount
  useEffect(() => {
    const storedData = sessionStorage.getItem(STORAGE_KEY);
    if (storedData) {
      const decryptedData = decryptData(storedData);
      if (decryptedData && decryptedData.tabs.length > 0) {
        setAppointmentTabs(decryptedData.tabs);
        setSelectedTab(decryptedData.lastTab >= 0 ? decryptedData.lastTab : 0);
      }
    }
  }, []);

  // Save Tabs in Storage on Change
  useEffect(() => {
    const encryptedTabs = encryptData({ tabs: appointmentTabs, lastTab: selectedTab });
    sessionStorage.setItem(STORAGE_KEY, encryptedTabs);
  }, [appointmentTabs, selectedTab]);

  // Open a New Appointment Tab with Source Prefix
  const handleOpenTab = (appointment, source) => {
    
    const sourceMap = {
      new: "N",
      today: "T",
      approved: "A",
      past: "P",
    };

    const sourcePrefix = sourceMap[source] || "U"; // Default to 'U' (Unknown) if source is invalid

    // Check if the same `pid` and `eid` exist
    const existingIndex = appointmentTabs.findIndex(
      (tab) => tab.pid === appointment.pc_pid && tab.eid === appointment.pc_eid
    );

    if (existingIndex === -1) {
      // New Tab Data
      const newTab = {
        pid: appointment.pc_pid,
        eid: appointment.pc_eid,
        uuid: appointment.patient_uuid,
        name: `${sourcePrefix} -${appointment.patient_fname} ${appointment.patient_lname} ${appointment.pc_eid}`, // Title format
        email: appointment.email,
        tabId: appointmentTabs.length + 4, // Offset existing tabs
      };

      const updatedTabs = [...appointmentTabs, newTab];
      setAppointmentTabs(updatedTabs);
      setSelectedTab(updatedTabs.length + 3);

      setTimeout(() => {
        navigate(`/provider/appointment/appot-data/${appointment.patient_uuid}/${appointment.pc_pid}/${appointment.pc_eid}`);
      }, 100);
    } else {
      // If the same tab exists, switch to it
      setSelectedTab(existingIndex + 4);
      navigate(`/provider/appointment/appot-data/${appointmentTabs[existingIndex].uuid}/${appointmentTabs[existingIndex].pid}/${appointmentTabs[existingIndex].eid}`);
    }
  };

  // Close a Tab
  const handleCloseTab = (index) => {
    const updatedTabs = appointmentTabs.filter((_, i) => i !== index);
    setAppointmentTabs(updatedTabs);

    if (updatedTabs.length === 0) {
      setSelectedTab(0);
      navigate("/provider/appointments");
    } else {
      setSelectedTab(Math.max(0, selectedTab - 1));
    }
  };

  // Handle Tab Change
  const handleTabChange = (_, newValue) => {
    setSelectedTab(newValue);

    if (newValue < 4) {
      navigate("/provider/appointments");
    } else {
      const selectedAppointment = appointmentTabs[newValue - 4];
      if (selectedAppointment) {
        navigate(`/provider/appointment/appot-data/${selectedAppointment.uuid}/${selectedAppointment.pid}/${selectedAppointment.eid}`);
      }
    }
  };

  return (
    <Box>
      {/* Tabs Section */}
      <Tabs value={selectedTab} onChange={handleTabChange} variant="scrollable">
        <Tab label="New Requests" />
        <Tab label="Today's Appointments" />
        <Tab label="Approved Appointments" />
        <Tab label="Past Appointments" />

        {appointmentTabs.map((tab, index) => (
          <Tab
            key={`${tab.pid}-${tab.eid}`} // Ensure unique key
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {tab.name}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseTab(index);
                  }}
                  sx={{ marginLeft: 1 }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Content Section */}
      <Box sx={{ marginTop: 2 }}>
        {selectedTab === 0 && <NewRequests onAppointmentSelect={(appointment) => handleOpenTab(appointment, "new")} />}
        {selectedTab === 1 && <TodaysAppointments onAppointmentSelect={(appointment) => handleOpenTab(appointment, "today")} />}
        {selectedTab === 2 && <ApprovedAppointments onAppointmentSelect={(appointment) => handleOpenTab(appointment, "approved")} />}
        {selectedTab === 3 && <PastAppointments onAppointmentSelect={(appointment) => handleOpenTab(appointment, "past")} />}
      </Box>
    </Box>
  );
};

export default AllAppointments;
